import { render, staticRenderFns } from "./AdminDubbo.vue?vue&type=template&id=4cf7b102"
import script from "./AdminDubbo.vue?vue&type=script&lang=js"
export * from "./AdminDubbo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports